<template>
  <div class="search-widget">
    <h2 class="search-widget__title">
      {{ title }}
      <svg
        viewBox="0 0 1.68 1.68"
        height="24px"
        width="24px"
        fill="#fff"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M0.801 0.38c0.008 0 0.013 -0.005 0.015 -0.013 0.022 -0.117 0.02 -0.12 0.143 -0.143 0.008 -0.001 0.013 -0.006 0.013 -0.015 0 -0.008 -0.005 -0.013 -0.013 -0.015 -0.122 -0.025 -0.118 -0.027 -0.143 -0.143 -0.002 -0.008 -0.006 -0.013 -0.015 -0.013s-0.013 0.005 -0.015 0.013c-0.025 0.116 -0.02 0.119 -0.143 0.143 -0.008 0.001 -0.013 0.006 -0.013 0.015 0 0.008 0.006 0.013 0.013 0.015 0.122 0.025 0.121 0.026 0.143 0.143 0.002 0.008 0.006 0.013 0.015 0.013M0.46 0.864c0.013 0 0.022 -0.008 0.024 -0.021 0.025 -0.188 0.032 -0.188 0.226 -0.225 0.013 -0.002 0.022 -0.011 0.022 -0.024 0 -0.013 -0.009 -0.022 -0.022 -0.024 -0.194 -0.027 -0.201 -0.033 -0.226 -0.224 -0.001 -0.013 -0.011 -0.022 -0.024 -0.022 -0.013 0 -0.022 0.009 -0.023 0.022 -0.023 0.188 -0.033 0.188 -0.226 0.224 -0.013 0.003 -0.022 0.011 -0.022 0.024 0 0.014 0.009 0.022 0.025 0.024 0.191 0.031 0.2 0.036 0.223 0.224 0.001 0.014 0.011 0.022 0.023 0.022m0.477 0.778c0.018 0 0.032 -0.013 0.035 -0.032 0.05 -0.385 0.104 -0.444 0.485 -0.486 0.02 -0.002 0.033 -0.017 0.033 -0.035s-0.013 -0.032 -0.033 -0.035c-0.381 -0.042 -0.435 -0.101 -0.485 -0.486 -0.004 -0.019 -0.017 -0.032 -0.035 -0.032s-0.032 0.013 -0.034 0.032c-0.05 0.385 -0.105 0.444 -0.485 0.486 -0.02 0.003 -0.034 0.017 -0.034 0.035 0 0.018 0.013 0.033 0.034 0.035 0.38 0.05 0.432 0.101 0.485 0.486 0.003 0.019 0.016 0.032 0.034 0.032"
        ></path>
      </svg>
      {{ titleEnd }}
    </h2>
    <div class="search-widget__bar">
      <input
        ref="searchInput"
        class="search-widget__input"
        v-model="search"
        type="text"
        :placeholder="placeholder"
        @keyup.enter="showCommandsDialog"
        @keydown="handleKeyDown"
      />
      <button class="search-widget__submit" @click="showCommandsDialog">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="20px"
          width="20px"
          viewBox="0 0 24 24"
          fill="#fff"
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
        </svg>
      </button>
    </div>
    <p class="search-widget__hint">
      <span class="search-widget__shortcut" @click="showCommandsDialog"
        >{{ shortcut.symbol }}+K</span
      >
      <span>
        You can access this anywhere
        <template v-if="!isMobile"
          >with <strong>{{ shortcut.text }} + K</strong></template
        >
      </span>
    </p>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
  name: 'HomeSearch',
  data() {
    return {
      search: '',
    };
  },
  props: {
    placeholder: {
      type: String,
      default: 'Search...',
    },
    title: {
      type: String,
      default: '',
    },
    titleEnd: {
      type: String,
      default: '',
    },
    searchAction: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    shortcut() {
      return this.getShortcut();
    },
  },
  methods: {
    getPlatform() {
      let platform = '';

      if (navigator.userAgentData && navigator.userAgentData.platform) {
        platform = navigator.userAgentData.platform;
      } else if (navigator.platform) {
        platform = navigator.platform;
      } else {
        platform = navigator.userAgent; // very old fallback
      }

      return /Mac/i.test(platform);
    },

    getShortcut() {
      const isMac = this.getPlatform();

      if (isMac) {
        return {
          symbol: '⌘',
          text: 'Command',
        };
      } else {
        return {
          symbol: 'Ctrl',
          text: 'Control',
        };
      }
    },

    showCommandsDialog: debounce(function () {
      this.searchAction(this.search);
      //EventBus.$emit('openCommandModal', { search: this.search });
      this.search = '';

      this.blurInput();
    }, 300),

    blurInput() {
      this.$refs.searchInput.blur();
    },

    handleKeyDown(event) {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        event.stopPropagation();
        this.showCommandsDialog();
      }
    },
  },
};
</script>

<style lang="less">
@button-gradient-start: #1bc0af; // fresh light cyan
@button-gradient-end: #1be3cf; // bright aqua

@placeholder-color: #888;
@glow-color: rgba(0, 0, 0, 0.15);

.search-widget {
  background: var(--gradient);
  border-radius: @base-radius;
  padding: 16px 16px 20px;
  color: #fff;
  margin: 6px 0;
  box-shadow: 0 4px 20px @glow-color;
  overflow: hidden;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      145deg,
      rgba(255, 255, 255, 0.12) 0%,
      transparent 100%
    );
    border-radius: inherit;
    pointer-events: none;
  }

  &__title {
    font-size: 20px;
    margin-bottom: 12px;
    font-weight: 600;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  }

  &__bar {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }

  &__input {
    flex: 1;
    padding: 12px 16px;
    border: 1px solid #ccc;
    border-radius: 6px 0 0 6px;
    font-size: 15px;
    color: #333;
    background-color: #fff;
    outline: none;
    transition: border-color 0.3s ease;

    &:focus {
      border-color: #15aeb4;
    }

    &::placeholder {
      color: @placeholder-color;
    }
  }

  &__submit {
    padding: 0 20px;
    height: 49px;
    border: none;
    background: linear-gradient(
      135deg,
      @button-gradient-start,
      @button-gradient-end
    );
    color: #fff;
    font-size: 18px;
    border-radius: 0 6px 6px 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    transition: background 0.3s ease, transform 0.3s ease;

    &:hover {
      background: linear-gradient(
        135deg,
        lighten(@button-gradient-start, 8%),
        lighten(@button-gradient-end, 8%)
      );
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
    }

    v-icon {
      font-size: 22px;
    }
  }

  &__shortcut {
    display: inline-block;
    margin-right: 4px;
    font-size: 13px;
    color: #333;
    background: rgba(255, 255, 255, 0.8);
    padding: 4px 8px;
    border-radius: 5px;
    font-weight: 600;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    cursor: pointer;

    &:hover {
      background: #fff;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
    }
  }

  &__hint {
    font-size: 14px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    margin-bottom: 0 !important;

    strong {
      font-weight: 600;
    }

    span {
      opacity: 0.8;
    }
  }
}
</style>
